{
  "startTaxLossHarvesting": "Start a new Tax-Loss Harvesting",
  "youDontHavePermission": "You don't have permission to run TLH job",
  "newTLHJobRun": "New Tax-Loss Harvest job",
  "newTLHJobStarted": "The Tax-Loss Harvest analysis job is now running in the background.",
  "newTLHJobFailed": "The Tax-Loss Harvest analysis job failed to start. Try again later.",
  "analysisOn": "analysis on",
  "state": "State",
  "organization": "Organization",
  "table": {
    "ranAt": "ran at",
    "numEvents": "# of events (trades)",
    "state": "state",
    "organization": "organization",
    "user": "User",
    "account": "Account",
    "symbol": "Symbol",
    "substituteSymbol": "Substitute Symbol",
    "costBase": "Cost Base",
    "adjustedCostBase": "Adjusted Cost Base",
    "price": "Price",
    "sellQuantity": "Quantity",
    "expectedSellValue": "Expected Sell Value",
    "assetValueAsOf": "Value of this asset as of",
    "gainLossPercentage": "Gain (Loss) %",
    "gainLossValue": "Gain (Loss) $",
    "bookValue": "Book Value"
  },
  "errors": {
    "noSuchTLHJob": "No such Tax-Loss Harvest job"
  }
}
